import Vue from 'vue';
import VueToastr from 'vue-toastr';

Vue.use(VueToastr, {
  defaultTimeout: 5e3,
  defaultPosition: 'toast-top-right',
  defaultClickClose: true,
  defaultCloseButton: true,
  defaultCloseOnHover: true,
  defaultClassNames: ['animated', 'fadeIn'],
  defaultProgressBar: false,
});
